// extracted by mini-css-extract-plugin
module.exports = {"Tab":"index__Tab___2MT1c","activeTab":"index__activeTab___XdHbA"};